import { getEmissionFactorsRepository } from "../Infrastructure/EmissionFactors.repository";

export async function getEmissionFactorsLogic(params) {
  return getEmissionFactorsRepository(params);
}
